module.exports = __webpack_public_path__ + "static/futura-book-98a51fd8af38f790ee33f43a3c0c8559.eot";